import React from "react";
import PowerBy from "../PowerBy";
import { userDetailType } from "types";
import { Separate } from "components/ui";
import { AboutProfile, MyProfile } from "..";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import _, { isEmpty } from "lodash";
import { vCard } from "../ProfileTabs/MyProfile/ContactCard/vCard";
// import { AppCtx } from "data/context";
// import { Dialog, Transition } from "@headlessui/react";
// import { AppCtx } from "data/context";

interface Props {
  userData: userDetailType;
}

const ProfileView: React.FC<Props> = ({ userData }) => {
  // const { setConnectWithMeUser } = React.useContext(AppCtx);
  let navigate = useNavigate();

  // const {
  //   openSettingsModal,
  //   setOpenSettingsModal,
  // } = React.useContext(AppCtx);

  const redirect = (redirectLink: string | URL | undefined) => {
    window.open(redirectLink, "_blank");
  };

  const onCreateProfile = () => {
    navigate(`/`);
  };

  // const closeDialog = () => {
  //   setOpenSettingsModal(false);
  // };

  // const onEnableNotification = () => {
  //   Notification.requestPermission().then((permission) => {
  //     console.log(permission, "Notification Permission");
  //   });
  //   setOpenSettingsModal(false);
  // }

  // const onTap = () => {
  //   navigate(`/connect`);
  //   setConnectWithMeUser(userData);
  // };

  React.useEffect(() => {
    if (userData?.direct_on === true) {
      const autoRedirect = userData?.links.filter(
        (prio) => prio?.priority === 0
      )[0] as any;
      console.log(autoRedirect);
      if (autoRedirect?.social_icon === "create-contact.png" || autoRedirect?.is_contactCard) {
        console.log("create-contact.png");

        let card = new vCard();
        card.version = `3.0`;
        card.firstName = `${userData?.profile_name}`;
        card.lastName = "";
        card.cellPhone = `${autoRedirect?.link_value}`;
        card.email = `${userData?.email}`;
        card.url = `https://app.jod-e.com/viewprofile/${userData?.username}`;

        // check users details has emerguncy contact
        const emergencyDetails = userData?.links.filter(
          (linktype: any) => linktype.type === "emergency-contact"
        ) as any;
        if (emergencyDetails.length > 0) {
          card.otherPhone = `${
            JSON.parse(emergencyDetails[0].link_value).phoneNumber
          }`;
        }
        // check users details has personal details
        const personalDetails = userData?.links.filter(
          (linktype: any) => linktype?.type === "personal-information"
        )as any;
        if (emergencyDetails.length > 0) {
          card.birthday = moment(
            JSON.parse(personalDetails[0]?.link_value).dob
          ).toDate();
        }

        const socialLinks = userData?.links.filter(
          (linktype: any) => linktype?.type === "links"
        );
        const result: any = _.map(socialLinks, (value: any) => [
          value?.social_media_name,
          `${value?.web_prefix}${value?.link_value}`,
        ]);

        if (!isEmpty(result)) {
          card.socialUrls = new Map<string, string>(result);
          // card.socialUrls = new Map<string, string> ([["key1", "value1"],["key2", "key2"]])
        }
        card.getFormattedString();
        const file = new Blob([card.getFormattedString()], {
          type: "text/vcard;charset=utf-8",
        });
        const a = document.createElement("a");
        a.href = URL.createObjectURL(file);
        window.open(`${a}`);
        a.download = "vcard.vcf";
        return
      } else {
        let re = `${autoRedirect?.web_prefix}${autoRedirect?.link_value}`;
        redirect(re);
        return
      }
    }
  }, [userData?.direct_on, userData?.links]);

  return (
    <>
      <AboutProfile userData={userData} />
      <Separate dark={userData?.background_pic === "" ? true : false} />
      <MyProfile userData={userData} />
      {/* <Separate dark={userData?.background_pic === "" ? true : false} /> */}

      <div className="mb-6 flex justify-center px-4">
        {/*<button*/}
        {/*  type="button"*/}
        {/*  className={`${*/}
        {/*    userData?.background_pic === ""*/}
        {/*      ? "w-60 rounded bg-gold py-3 px-2 text-sm"*/}
        {/*      : "w-60 rounded bg-white/30 py-3 px-2 text-sm text-white backdrop-blur-md"*/}
        {/*  }`}*/}
        {/*  onClick={() => onCreateProfile()}*/}
        {/*>*/}
        {/*  Create Your Profile*/}
        {/*</button>*/}
        {/* <button
            type="button"
            className={`${
              userData?.background_pic === ""
                ? "w-40 rounded bg-gold py-3 px-2 text-sm"
                : "w-40 rounded bg-white/30 py-3 px-2 text-sm text-white backdrop-blur-md"
            }`}
            onClick={() => onTap()}
          >
            Tap To Connect
          </button> */}
      </div>

      {/*<PowerBy userData={userData} />*/}

      {/* <Transition appear show={openSettingsModal} as={Fragment}>
        <Dialog as="div" className="relative z-10" onClose={closeDialog}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-xs transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  >
                    Get updates from {userData?.profile_name}
                  </Dialog.Title>
                  <div className="mt-2">
                    <p className="text-sm text-gray-500">
                      Allow jod-e to send you regular updates
                    </p>
                  </div>
                  <div className="flex mt-4 justify-end">
                    <button
                      className="rounded-md border border-black w-16 mr-2 text-sm"
                      onClick={closeDialog}
                    >
                      No
                    </button>
                    <Button
                      size="small"
                      width="4rem"
                      onClick={() => onEnableNotification()}
                    >
                      Yes
                    </Button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition> */}
    </>
  );
};

export default ProfileView;
